<template>
  <vx-card>
    <vs-row
      vs-type="flex"
      class="mt-0 mb-4"
      vs-justify="center"
      vs-align="center"
      vs-w="12"
    >
      <vs-col
        vs-type="flex"
        vs-justify="flex-end"
        vs-align="flex-end"
        vs-w="12"
      >
        <vs-input
          color="dark"
          class="mx-1"
          type="date"
          size="small"
          label="Data De"
          v-model="filtro.dataDe"
        ></vs-input>
        <vs-input
          color="dark"
          class="mx-1"
          type="date"
          label="Data Até"
          size="small"
          v-model="filtro.dataAte"
        ></vs-input>
        <div class="mx-1">
          <label style="color: black; font-size: 0.85rem" class="pl-2"
            >Status Serviço</label
          >
          <br />
          <el-select
            filterable
            placeholder="Status do Serviço"
            size="small"
            clearable
            v-model="filtro.executado"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="status in statusServico"
              :value="status.id"
              :label="status.nome"
              :key="status.id"
            ></el-option>
          </el-select>
        </div>
        <div class="mx-1">
          <label style="color: black; font-size: 0.85rem" class="pl-2"
            >Colaborador</label
          >
          <br />
          <el-select
            filterable
            clearable
            remote
            size="small"
            :remote-method="filtroColaborador"
            placeholder="Pesquise"
            loading-text="Buscando..."
            :loading="loading"
            v-model="filtro.colaborador"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="colaborador in colaboradores"
              :value="colaborador.id"
              :label="colaborador.nome"
              :key="colaborador.id"
            ></el-option>
          </el-select>
        </div>
        <div class="mx-1">
          <label style="color: black; font-size: 0.85rem" class="pl-2"
            >Rota</label
          >
          <br />
          <el-select
            filterable
            clearable
            size="small"
            placeholder="Pesquise"
            v-model="filtro.rota"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="rota in rotas"
              :value="rota.id"
              :label="rota.nome"
              :key="rota.id"
            ></el-option>
          </el-select>
        </div>
        <div class="mx-1">
          <label style="color: black; font-size: 0.85rem" class="pl-2"
            >N° OS</label
          >
          <br />
          <el-input
            v-model="filtro.os"
            type="number"
            size="small"
            :popper-append-to-body="false"
            placeholder="Número da OS"
            min="0"
          >
          </el-input>
        </div>
        <el-button
          size="small"
          type="primary"
          class="mx-1"
          plain
          @click="filtrar()"
          >FILTRAR</el-button
        >
      </vs-col>
    </vs-row>
    <div id="retornosOS" class="mb-1 vs-con-loading__container retornos-container">
      <div v-if="retornosOS.length == 0" class="retornos-vazio">
        <div class="con-colors">
          <ul>
            <li class="danger-box">
              <h2 class="p-5" style="color: white !important">
                Nenhum Retorno
              </h2>
            </li>
          </ul>
        </div>
      </div>
      <div v-else>
        <b-table-simple responsive sticky-header="60vh" striped>
          <b-thead>
            <b-tr>
              <b-th class="text-center" style="width: 5%">Contrato</b-th>
              <b-th class="text-center" style="width: 5%">OS</b-th>
              <b-th style="width: 18%">Cliente</b-th>
              <b-th style="width: 15%">Técnico</b-th>
              <b-th class="text-center" style="width: 8%">Tipo Serviço</b-th>
              <b-th class="text-center" style="width: 10%">Data / Horário</b-th>
              <b-th class="text-center" style="width: 9%">Data Inicio</b-th>
              <b-th class="text-center" style="width: 9%">Data Fim</b-th>
              <b-th class="text-center" style="width: 10%">Observação</b-th>
              <b-th class="text-center" style="width: 5%">Etapas</b-th>
              <b-th class="text-center" style="width: 6%">Ações</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr
              v-for="(row, index) in retornosOS"
              :key="index"
              :style="
                row.executado == 1
                  ? 'color: green; background-color:#e8fce8 !important;'
                  : row.executado == 2
                  ? 'color:#dd3522; background-color: #f5efef !important'
                  : ''
              "
            >
              <b-td class="text-center" style="font-size: 12px">
                <a
                  target="_blank"
                  :href="'contrato?id=' + row.id_contrato"
                  style="color: darkblue; cursor: pointer; font-size: 12px"
                >
                  <b>{{ row.id_contrato }}</b>
                </a>
              </b-td>
              <b-td class="text-center" style="font-size: 12px">
                <b>{{ row.id }}</b>
              </b-td>
              <b-td style="font-size: 12px">
                <VisualizarCliente
                  @update="close()"
                  :id_cliente="row.id_cliente"
                  :nomeCliente="row.nomeCliente"
                />
              </b-td>
              <b-td style="font-size: 12px">
                <b>{{ row.colaborador }}</b>
              </b-td>
              <b-td class="text-center" style="font-size: 12px">
                <b>{{ row.tipoServico }}</b>
              </b-td>
              <b-td class="text-center" style="font-size: 12px">
                <b>{{ row.data }}</b>
              </b-td>
              <b-td class="text-center" style="font-size: 12px">
                <b>{{ row.data_inicio ? row.data_inicio : "--" }}</b>
              </b-td>
              <b-td class="text-center" style="font-size: 12px">
                <b>{{ row.data_fim ? row.data_fim : "--" }}</b>
              </b-td>
              <b-td class="text-center" style="font-size: 12px">
                <obs v-if="row.executado == 1" :os="row"></obs>
              </b-td>
              <b-td class="text-center">
                <el-popover
                  v-if="row.etapas && parseEtapas(row.etapas).length"
                  placement="left"
                  width="320"
                  trigger="click"
                >
                  <div class="etapas-popover">
                    <p class="etapas-titulo">Etapas do Retorno</p>
                    <div
                      v-for="(etapa, i) in parseEtapas(row.etapas)"
                      :key="i"
                      class="etapa-item"
                      :class="etapa.status === 1 && !etapa.text.toLowerCase().includes('erro') ? 'etapa-ok' : 'etapa-erro'"
                    >
                      <i class="material-icons etapa-icon">{{ etapa.status === 1 && !etapa.text.toLowerCase().includes('erro') ? 'check_circle' : 'cancel' }}</i>
                      <span>{{ etapa.text }}</span>
                    </div>
                  </div>
                  <el-button slot="reference" type="text" size="mini" style="padding:0">
                    <i class="material-icons" style="font-size:18px;color:#5a7fd4;vertical-align:middle">list_alt</i>
                    <span style="font-size:10px;color:#5a7fd4;vertical-align:middle">
                      {{ parseEtapas(row.etapas).length }}
                    </span>
                  </el-button>
                </el-popover>
                <span v-else style="color:#ccc;font-size:11px">—</span>
              </b-td>
              <b-td class="text-center">
                <vs-row vs-w="12" vs-align="center" vs-justify="center">
                  <vs-col
                      vs-w="6"
                      vs-align="center"
                      vs-justify="center"
                    >
                      <EnviarRelatorioOs 
                        :idOs="row.id" 
                        :executado="row.executado"
                        :divLoading="'retornosOS'"
                      />
                    </vs-col>
                  <vs-col vs-w="6" vs-align="center" vs-justify="center" v-if="row.executado != 2">
                    <vs-button
                      class="px-0 py-0 m-0"
                      icon="remove_red_eye"
                      :disabled="!(row.executado == 1)"
                      color="success"
                      @click="redirectBlank(row)"
                      size="small"
                      type="filled"
                    ></vs-button>
                  </vs-col>
                  <vs-col vs-w="6" vs-align="center" vs-justify="center" v-else>
                    <OsNaoExec :os="row" />
                  </vs-col>
                </vs-row>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>

        <div class="flex flex-wrap items-center justify-between px-2 py-1">
          <span class="text-sm text-grey-dark"></span>
          <vs-pagination
            :total="paginacao.totalPaginas || 1"
            :value="pagina"
            @input="navegarPagina"
          />
        </div>
      </div>
      <vx-card class="mt-4" no-shadow card-background="dark">
          <vs-row vs-type="flex" vs-justify="flex-end">
            <vs-col vs-w="12" vs-type="flex" vs-justify="flex-end" vs-align="center">
              <vs-col
                vs-w="3"
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="center"
              >
                <span class="text-white">
                  Retornos: {{ paginacao.total }}
                </span>
              </vs-col>
              <vs-col
                vs-w="4"
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="center"
              >
                <span class="text-white">
                  Executados: {{ paginacao.executadas }}
                </span>
              </vs-col>
              <vs-col
                vs-w="4"
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="center"
              >
                <span class="text-white">
                  Não Executados: {{ paginacao.naoExecutadas }}
                </span>
              </vs-col>
              <vs-col
                vs-w="6"
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="center"
              >
                <span class="text-white">
                  Página {{ paginacao.pagina }} de {{ paginacao.totalPaginas || 1 }}
                </span>
              </vs-col>
              <vs-col
                vs-w="6"
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="center"
              >
                <span class="text-white">
                  Exibindo {{ retornosOS.length }} de {{ paginacao.total }} registros
                </span>
              </vs-col>
            </vs-col>
          </vs-row>
        </vx-card>
    </div>
  </vx-card>
</template>

<script>
import obs from "./obsModal"
import components from "@/components/default/exports.js"
import OsNaoExec from "./../agenda-servicos/os/components/osNaoExec.vue"
import VisualizarCliente from "./../cliente/visualizar.vue"
import EnviarRelatorioOs from "@/components/default/enviarRelatorioOs.vue"
export default {
  data () {
    return {
      retornosOS: [],
      colaboradores: [],
      tiporetornosOS: [],
      estagios: [],
      statusServico: [
        { id: 1, nome: "Executado" },
        { id: 0, nome: "Não Executado" },
      ],
      loading: false,
      pagina: 1,
      filtro: {
        dataHoje: this.$formartData.dataFiltro(),
        itensPorPagina: 100,
        dataDe: "",
        dataAte: "",
        executado: null,
        colaborador: null,
        rota: null,
        os: null,
      },
      paginacao: {
        total: 0,
        pagina: 1,
        itensPorPagina: 100,
        totalPaginas: 0,
      },
      rotas: [],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.8,
      },
      relatorioUrl: ""
    }
  },
  methods: {
    async getRetornos () {
      await this.$vs.loading({ container: "#retornosOS", scale: 0.6 })
      try {
      const res = await this.$http.post(`getRetornosOS`, { ...this.filtro, pagina: this.pagina })
        this.retornosOS = res.retornosOS
        this.relatorioUrl = res.relatorioUrl
        if (res.paginacao) {
          this.paginacao = res.paginacao
        }
      } catch (err) {
        const error = this.$httpErrors(err)
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        }
      } finally {
        await this.$vs.loading.close("#retornosOS > .con-vs-loading")
      }
    },
    filtrar () {
      this.pagina = 1
      this.getRetornos()
    },
    navegarPagina (val) {
      if (val === this.pagina) return
      this.pagina = val
      this.getRetornos()
    },
    async getColaboradoresByQuery (query) {
      try {
        this.colaboradores = await this.$http.post(`getColaboradorByQuery`, {
          query: query,
        })
      } catch (err) {
        const error = this.$httpErrors(err)
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        }
      }
    },
    async filtroColaborador (query) {
      if (query.length > 2) {
        this.loading = true
        try {
          await this.getColaboradoresByQuery(query)
        } catch (err) {
          const error = this.$httpErrors(err)
          this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        }
        } finally {
          this.loading = false
        }
      }
    },
    async redirectBlank (os) {
      const link = `${this.relatorioUrl}/?os=${os.id}`
      var a = document.createElement("a")
      a.target = "_blank"
      a.href = link
      a.click()
    },

    
    async mountData () {
      const date = new Date()
      const firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
        .toISOString()
        .split("T")[0]
      const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
        .toISOString()
        .split("T")[0]
      this.filtro.dataDe = firstDay
      this.filtro.dataAte = lastDay
    },
    async getRotas () {
      try {
        this.rotas = await this.$http.get(`rota`)
      } catch (err) {
        const error = this.$httpErrors(err)
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        }
      }
    },
    async getEstagios () {
      try {
        this.estagios = await this.$http.get(`contrato_estagio`)
      } catch (err) {
        const error = this.$httpErrors(err)
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        }
      }
    },
    parseEtapas (etapas) {
      if (!etapas) return []
      try {
        return typeof etapas === 'string' ? JSON.parse(etapas) : etapas
      } catch {
        return []
      }
    },
  },
  async mounted () {
    await this.mountData()
    await this.getRetornos()
    await this.getRotas()
  },
  components: { ...components, VisualizarCliente, OsNaoExec, obs, EnviarRelatorioOs },
};
</script>
<style lang="scss">

.retornos-container {
  min-height: 60vh;
  display: flex;
  flex-direction: column;
}

.retornos-vazio {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
}

.b-table-sticky-header {
  height: 60vh !important;
  border-top: 1px solid #dee2e6;
  border-left: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
  border-radius: 4px 4px 0 0;
}

.cardTable {
  transition-duration: 300ms;
  border-style: solid;
  border-radius: 4px;
  border-color: rgba(211, 211, 211, 0.493);
  border-width: 2px;
  &:hover {
    transition-duration: 555ms;
    transform: translateY(-3px);
    box-shadow: 0px 4px 25px 0px rgba(226, 226, 226, 0.25);
  }
}
.etapas-popover {
  max-height: 360px;
  overflow-y: auto;
  padding: 4px 0;
  .etapas-titulo {
    font-weight: 700;
    font-size: 13px;
    margin-bottom: 8px;
    color: #333;
    border-bottom: 1px solid #eee;
    padding-bottom: 6px;
  }
  .etapa-item {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 4px 2px;
    font-size: 12px;
    border-radius: 4px;
    margin-bottom: 2px;
    .etapa-icon {
      font-size: 15px;
      flex-shrink: 0;
    }
  }
  .etapa-ok {
    color: #27ae60;
    background: #f0fff4;
  }
  .etapa-erro {
    color: #e74c3c;
    background: #fff0f0;
  }
}
</style>
